import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import ArticleShow from './views/ArticleShow'
import Nofind from './views/404'
import NewsList from './views/NewsList'
import Home from './views/Home'
import InqCert from './views/InqCert'
import CertResult from './views/CertResult'

// import {
//   createRouter,
//   createWebHistory
// } from "vue-router";
Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const router = new Router({
  mode: 'history',
  linkExactActiveClass: "selected",
  base: process.env.BASE_URL,

  routes: [{
      path: '*',
      name: '/404',
      component: Nofind
    },
    
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [{
          path: '',
          component: Home
        },
        {
          path: '/',
          name: 'home', //首页
          component: Home
        },
        {
          path: '/news/info/:plateId/:articleId', //显示文章内容
          name: 'infoArticle',
          component: ArticleShow
        },
        {
          path: '/news/views/:plateId', //显示更多文章
          name: 'newsList',
          component: NewsList
        }, {
          path: '/certresult',
          name: 'CertResult',
          component: CertResult
        }, {
          path: '/inqCert',
          name: 'InqCert',
          component: InqCert
        },{
          path: '/inqCertM',
          name: 'InqCertM',
          component:InqCert
        },
        // {
        //   path: '/createCertZy',
        //   name: 'createCertZy',
        //   component:createCertZy
        // },
      ]
    },
  ]
})

// // // 添加路由守卫
// router.beforeEach((to, from, next) => {
//   const isLogin = localStorage.eleToken ? true : false;
//   // if (to.path == "/inqCert" &&isPhone()) {
//   //   next("/inqCertM");
//   // } else {
//     next();
//   // }
// })
function isPhone() {
  var mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return mobile != null
}
export default router;